
















import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class LanguagesButtons extends Vue {
  activeLanguage = this.$store.getters.getLanguages[0];

  isActive(id: string): string {
    if (id == this.activeLanguage) {
      return "primary";
    }
    return "outline-primary";
  }
}
